module.exports = __webpack_public_path__ + "tab_jindu_default.png?81f821b79e0c174cd1b74c7ea8fe2946";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_jindu_default.png
// module id = 136
// module chunks = 0